<template>
    <div :class="['tag', { disabled: disabled }, { inverted: inverted }]" @click.self="$emit('click')">
        <div class="content">
            <p class="text" @click.self="$emit('click')">{{ tag }}</p>
            <p v-if="subtext" class="subtext">{{ subtext }}</p>
        </div>
        <button v-if="!disabled && !inverted" @click="removeTag(tag)">
            <Close />
        </button>
    </div>
</template>

<script>
import Close from '@/components/Icon/Close.vue';

export default {
    name: 'SelectedTag',
    components: {
        Close,
    },
    props: {
        tag: {
            type: String,
            required: true,
        },
        removeTag: {
            type: Function,
            required: false,
            default: () => {},
        },
        disabled: {
            type: Boolean,
            required: false,
        },
        inverted: {
            type: Boolean,
            required: false,
        },
        subtext: {
            type: String,
            default: '',
        },
    },
};
</script>

<style scoped>
.tag,
.tag * {
    margin: 0;
    padding: 0;
}

.tag {
    background-color: #1c84b2;
    padding: 11px 10px 11px 12px;
    min-height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    color: var(--color-white);
    border-radius: 40px;
}

.tag.disabled {
    background-color: #f2f2f2;
    color: var(--color-black);
}

.tag.inverted {
    background-color: var(--color-white);
    color: #1c84b2;
    border: 1px solid #1c84b2;
    text-align: center;
    cursor: pointer;
}

.tag.inverted:hover {
    background-color: #1c84b2;
    color: #fff;
}

.tag.inverted p {
    margin: 0;
}

.tag .content {
    display: flex;
    flex-direction: column;
}

.tag p {
    font-size: 14px;
    line-height: 16px;
    margin-right: 8px;
}

.tag button {
    background: none;
    border: 0;
    color: inherit;
    width: 16px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
